<div class="nc-container">
  <div class="nc-info" [innerHTML]="'cookies_config_Data1' |i18n"></div>
  <div class="nc-options-container">
    <div class="btn nc-config" [innerHTML]="'cookies_config_Data2' | i18n" (click)="openOptionalCookiesDialog()"></div>
    <div class="btn nc-deny" [innerHTML]="'cookies_config_Data3' | i18n" (click)="acceptCookies(cookiesConfigEnum.ESSENTIAL)"></div>
    <div class="btn nc-accept" [innerHTML]="'cookies_config_Data4' | i18n" (click)="acceptCookies(cookiesConfigEnum.ALL)"></div>
  </div>
</div>
